import React from 'react'
import { SliderQuestionInput } from 'components/SliderQuestionInput'
import RatingScaleMinmaxQuestionInput from 'components/RatingScaleMinmaxQuestionInput'
import { CsatInput } from 'components/CsatInput'
import StarQuestionInput from 'components/StarQuestionInput'

export default function PrimaryQuestionTextInput({ metric }) {
  if (metric === 'CSAT') {
    return <CsatInput />
  }

  if (metric === 'NPS') {
    return <SliderQuestionInput />
  }

  if (metric === 'CES') {
    return <RatingScaleMinmaxQuestionInput />
  }

  if (metric === '5-STAR') {
    return <StarQuestionInput />
  }

  return null
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/PrimaryQuestionInput/PrimaryQuestionTextInput.js